import { render } from "./PointHistory.vue?vue&type=template&id=23dc3938"
import script from "./PointHistory.vue?vue&type=script&lang=js"
export * from "./PointHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__